import { render, staticRenderFns } from "./BM.vue?vue&type=template&id=38346a9a"
import script from "./BM.vue?vue&type=script&lang=js"
export * from "./BM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports